import React from 'react'

import clsx from 'clsx'
import Masonry from 'react-masonry-css'

import ArticleCard from 'components/ArticleCard'
import { EventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import BlockHeading from '../../../components/BlockHeading'

import classes from './RelatedPosts.module.scss'

/** @type {import('./types').default} */
const RelatedPosts = ({ posts, topicTitle }) => {
  const { is } = useViewport()

  let masonryDefaultColumns = 3
  if (is('xs')) {
    masonryDefaultColumns = 1
  } else if (is('sm')) {
    masonryDefaultColumns = 2
  }

  if (!posts?.length) {
    return null
  }

  return (
    <div className="RelatedPosts">
      <EventContext value={{ engagementComponent: 'resources_article' }}>
        <BlockHeading>More on {topicTitle}</BlockHeading>
        <Masonry
          className={clsx('mansory', classes.masonry)}
          breakpointCols={{
            default: masonryDefaultColumns,
            959: 2,
            599: 1,
          }}
        >
          {posts.map(post => (
            <div key={post.sys.id}>
              <ArticleCard hideTags post={post} />
            </div>
          ))}
        </Masonry>
      </EventContext>
    </div>
  )
}

export default RelatedPosts
